/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DigiticketsScheduleMap } from './DigiticketsScheduleMap';
import {
    DigiticketsScheduleMapFromJSON,
    DigiticketsScheduleMapFromJSONTyped,
    DigiticketsScheduleMapToJSON,
    DigiticketsScheduleMapToJSONTyped,
} from './DigiticketsScheduleMap';

/**
 * 
 * @export
 * @interface CreateDigiticketsScheduleMapResponse
 */
export interface CreateDigiticketsScheduleMapResponse {
    /**
     * 
     * @type {DigiticketsScheduleMap}
     * @memberof CreateDigiticketsScheduleMapResponse
     */
    data: DigiticketsScheduleMap;
}

/**
 * Check if a given object implements the CreateDigiticketsScheduleMapResponse interface.
 */
export function instanceOfCreateDigiticketsScheduleMapResponse(value: object): value is CreateDigiticketsScheduleMapResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateDigiticketsScheduleMapResponseFromJSON(json: any): CreateDigiticketsScheduleMapResponse {
    return CreateDigiticketsScheduleMapResponseFromJSONTyped(json, false);
}

export function CreateDigiticketsScheduleMapResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDigiticketsScheduleMapResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': DigiticketsScheduleMapFromJSON(json['data']),
    };
}

  export function CreateDigiticketsScheduleMapResponseToJSON(json: any): CreateDigiticketsScheduleMapResponse {
      return CreateDigiticketsScheduleMapResponseToJSONTyped(json, false);
  }

  export function CreateDigiticketsScheduleMapResponseToJSONTyped(value?: CreateDigiticketsScheduleMapResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DigiticketsScheduleMapToJSON(value['data']),
    };
}

